import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Fab,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Tooltip
} from '@mui/material';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { UserDto } from '../../common/PricePrgClient';
import { UserAvatar } from '../../common/UserAvatar';
import { RootState } from '../../store';
import { showConfirmDialog } from '../ui/redux/uiSlices';
import AddUserGroupMemberDialog from './dialogs/AddUserGroupMemberDialog';
import { getSelectedUserGroup, getUserGroupMembers } from './redux/userGroupSelectors';
import { removeMemberFromGroup } from './redux/userGroupSlices';
const mapStateToProps = (state: RootState) => ({
    members: getUserGroupMembers(state),
    selectedUserGroup: getSelectedUserGroup(state)
});

type Props = ReturnType<typeof mapStateToProps>;
const ManageGroupMembers = ({ selectedUserGroup, members }: Props) => {
    const [showAddUserGroupMemberDialog, setShowAddUserGroupMemberDialog] = useState(false);

    const dispatch = useDispatch();

    if (selectedUserGroup == null) {
        return <div />;
    }

    const handleAddMemberClick = () => {
        setShowAddUserGroupMemberDialog(true);
    };

    const handleHideUserGroupMemberDialog = () => {
        setShowAddUserGroupMemberDialog(false);
    };

    const handleRemoveUserFromGroup = (user: UserDto) => {
        dispatch(
            showConfirmDialog({
                dialogTitle: `Remove ${user.username} from group`,
                dialogMessage: `Do you want to remove ${user.username} from ${selectedUserGroup.name}?`,
                primaryActionName: 'Remove',
                okAction: removeMemberFromGroup.request({
                    userGroupId: selectedUserGroup.userGroupId,
                    userId: user.userId
                })
            })
        );
    };

    return (
        <>
            <Grid container direction="column" sx={{ maxWidth: 600 }}>
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <Tooltip title="Add user to group">
                                <span>
                                    <Fab size="small" color="primary" onClick={handleAddMemberClick}>
                                        <AddIcon />
                                    </Fab>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <List>
                        {members.map(m => (
                            <ListItem key={m.userId}>
                                <ListItemText>
                                    <UserAvatar user={m} iconOnly={false} />
                                </ListItemText>
                                <ListItemSecondaryAction>
                                    <Tooltip title={`Remove ${m.username} from group`}>
                                        <IconButton
                                            onClick={() => handleRemoveUserFromGroup(m)}
                                            color="secondary"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>

            {showAddUserGroupMemberDialog && (
                <AddUserGroupMemberDialog closeDialog={handleHideUserGroupMemberDialog} />
            )}
        </>
    );
};

export default connect(mapStateToProps)(ManageGroupMembers);
